import { Search, Plus, Menu, Cloud, CloudOff } from '../../lib/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { surSync, etatSync } from '../../lib/store';

export const Header = ({ query, onQueryChange, onMenuClick }) => {
  const navigate = useNavigate();
  const [sync, setSync] = useState(etatSync);
  useEffect(() => surSync(setSync), []);

  return (
    <header
      data-testid="app-header"
      className="flex h-16 flex-shrink-0 items-center gap-2 border-b border-slate-200 bg-white px-3 sm:gap-4 sm:px-6"
    >
      <button
        type="button"
        data-testid="mobile-menu-button"
        aria-label="Ouvrir le menu"
        onClick={onMenuClick}
        className="flex h-11 w-11 flex-shrink-0 items-center justify-center border border-slate-300 text-slate-800 transition-colors duration-150 hover:bg-slate-900 hover:text-white md:hidden"
      >
        <Menu size={20} />
      </button>

      <div className="relative flex-1 max-w-3xl">
        <Search size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          data-testid="universal-search-input"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Recherche : fournisseur, lot, facture…"
          className="h-11 w-full border border-slate-300 bg-slate-50 pl-9 pr-3 text-base text-slate-900 outline-none transition-colors duration-150 placeholder:text-slate-400 focus:border-slate-900 focus:bg-white sm:h-10 sm:text-sm"
        />
      </div>

      <span
        data-testid="indicateur-base-partagee"
        title={sync.connecte ? 'Base partagée MongoDB — données communes à tous les postes' : 'Serveur injoignable — cache local'}
        className={`hidden flex-shrink-0 items-center gap-1.5 border px-2 py-1 font-data text-[10px] uppercase tracking-[0.08em] lg:flex ${
          sync.connecte ? 'border-emerald-300 bg-emerald-50 text-emerald-700' : 'border-amber-300 bg-amber-50 text-amber-800'
        }`}
      >
        {sync.connecte ? <Cloud size={12} /> : <CloudOff size={12} />}
        {sync.connecte ? 'Base partagée' : 'Hors ligne'}
      </span>

      <button
        type="button"
        data-testid="new-operation-button"
        onClick={() => navigate('/reception?nouveau=1')}
        className="flex h-11 flex-shrink-0 items-center gap-2 bg-slate-900 px-3 font-heading text-sm font-bold text-white transition-colors duration-150 hover:bg-slate-700 sm:h-10 sm:px-4"
      >
        <Plus size={18} />
        <span className="hidden sm:inline">Nouvelle Opération</span>
      </button>
    </header>
  );
};
